import React, { Component } from 'react'
import { Card, Popconfirm, Icon, message } from 'antd'
import { observer } from "mobx-react"
import Modal from 'react-modal'
import { submitVote as submitVoteContract } from '../../../contract/CustomWagersController'
import { submitVote as submitVoteApi } from '../../../api-calls/customWagers'

@observer(["AuthStore", "UserStore", "TeamStore"])
export default class SubmitVote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            voteModalIsOpen: false,
            makerChoice: 0,
            oneBackground: "rgba(255, 255, 255, 0.04)",
            twoBackground: "rgba(255, 255, 255, 0.04)",
            oneTextColor: "#40a9ff",
            twoTextColor: "#40a9ff",
            chosenWinner: null,

        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submitVote = this.submitVote.bind(this);
        this.outcomeOneClicked = this.outcomeOneClicked.bind(this);
        this.outcomeTwoClicked = this.outcomeTwoClicked.bind(this);
    }


    submitVote() {
        const { AuthStore, UserStore } = this.props;
        let bytes32Id = this.props.wager.bytes32Id;
        let wagerId = this.props.wager._id;
        let userId = UserStore.user._id;
        let authToken = AuthStore.userAuth.auth.accessToken;
        let chosenWinner = this.state.chosenWinner;
        let winnerVote;
        let self = this;

        console.log("Submitting vote for bet " + this.props.wager.bytes32Id);
        console.log("choice " + chosenWinner);

        if (chosenWinner == null) {
            message.info("You must select a winner!");
        } else {
            submitVoteContract(bytes32Id, chosenWinner).then(
                function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! Vote not submit.");
                    } else {
                        return submitVoteApi(
                            authToken,
                            wagerId,
                            bytes32Id,
                            chosenWinner,
                        ).then(function () {
                            self.setState({ voteModalIsOpen: false });
                            return UserStore.updateUser(authToken);
                        });
                    }
                });
        }
    }

    openModal() {
        this.setState({ voteModalIsOpen: true });

    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ voteModalIsOpen: false });
    }


    outcomeOneClicked() {
        this.setState({
            twoBackground: "#041827",
            oneBackground: "#1890ff",
            chosenWinner: 1,
            oneTextColor: '#000',
            twoTextColor: '#40a9ff'

        });

    }

    outcomeTwoClicked() {
        this.setState({
            oneBackground: "#041827",
            twoBackground: "#1890ff",
            chosenWinner: 2,
            twoTextColor: '#000',
            oneTextColor: '#40a9ff'
        });
    }

    render() {


        const submitVoteModal = <Modal
            isOpen={this.state.voteModalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            className="new-bet-modal"
            overlayClassName="new-bet-modal-overlay"
        >
            <div className="modal-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
            <h3 className="single-event-oracle-titles">Who won the bet?</h3>
            <div style={{ textAlign: "center", display: "flex", flexDirection: "row", padding: "30px" }}>
                <div style={{ marginRight: '25px' }}>
                    <Card onClick={this.outcomeOneClicked} bordered={false} style={{ cursor: 'pointer', background: this.state.oneBackground, width: '100%', padding: "30px" }}>
                        <div style={{ color: this.state.oneTextColor }} className="single-event-oracle-subtitles">{this.props.makerTaker == "maker" ? "Maker (You)" : <span>Maker: {this.props.wager.maker}</span>}</div>
                        <h3 className="single-event-oracle-subtitles">{this.props.wager.outcomeOne}</h3>
                    </Card>
                </div>
                <div>
                    <Card onClick={this.outcomeTwoClicked} bordered={false} style={{ cursor: 'pointer', background: this.state.twoBackground, width: '100%', padding: "30px" }}>
                        <div style={{ color: this.state.twoTextColor }} className="single-event-oracle-subtitles">{this.props.makerTaker == "taker" ? "Taker (You)" : <span>Taker: {this.props.wager.taker}</span>}</div>
                        <h3 className="single-event-oracle-subtitles">{this.props.wager.outcomeTwo}</h3>
                    </Card>
                </div>
            </div>
            <br />
            <br />
            <button onClick={this.closeModal} className="custom-btn-danger">Exit</button>
            <button onClick={this.submitVote} className="custom-btn-success">Submit</button>


        </Modal>
        return (
            <div>
                {submitVoteModal}
                <button className="custom-btn-primary" onClick={this.openModal}>Select Winner</button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/customWagerStages/SubmitVote.js